<template>
  <div id="app">
    <router-view />
    <div
      v-if="isOpenAdsPopup && !(loadingPage && loadingInfoV4)"
      class="adv-popup-overlay"
    >
      <div class="adv-popup-container">
        <button class="adv-popup-close-button adv-popup-close-action" @click="closeAdsPopup()">
        </button>
        <img
          :src="
            `https://hn.ss.bfcplatform.vn/landingpage-builder/popup_ads.png?t=${Date.now()}`
          "
          alt="Ads"
          class="adv-popup-img"
          @click="toActionAdsPopup()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { spaNavigateGuard } from '@bizfly/shared';

export default {
  name: 'App',
  data() {
    return {
      isOpenAdsPopup: false,
    };
  },
  computed: {
    ...mapGetters('loading', ['loadingPage', 'loadingInfoV4']),
  },
  mounted() {
    this.checkOpenAdsPopup();
  },
  methods: {
    checkOpenAdsPopup() {
      const lastShowAdsPopup = localStorage.getItem('adsPopup');
      if (lastShowAdsPopup !== 's3_free_10GB') {
        this.isOpenAdsPopup = true;
      }
    },
    closeAdsPopup() {
      localStorage.setItem('adsPopup', 's3_free_10GB');
      this.isOpenAdsPopup = false;
    },
    toActionAdsPopup() {
      localStorage.setItem('adsPopup', 's3_free_10GB');
      spaNavigateGuard('/simple-storage/storage/create');
    },
  },
};
</script>

<style lang="scss">
.adv-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.adv-popup-container {
  position: relative;
  padding: 20px;
}

.adv-popup-img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.adv-popup-close-button {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 40px;
  height: 40px;
  padding: 1px 0px 0px 1px;
  font-size: 25px;
  font-family: bf-icon !important;
  color: #9e9e9e;
  background-color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;
  &::before {
    content: "\e920";
  }
  &:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    transform: scale(1.1);
    transition: 0.2s;
  }
}
</style>
